import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../dfp-component";

const AdsFiller = () => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  let currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""))
    .split("?")[0]
    .split("/")[1];
  if (currentPath === "") {
    currentPath = pageType;
  }

  const topFillerAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "top_filler_ad"], {})
  );

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  return (
    <>
      {isDesktop && (
        <DfpComponent adStyleName="top-ad-filler" id={topFillerAdConfig?.id} isSponsored={true} centerText={true} />
      )}
    </>
  );
};

AdsFiller.propTypes = {};

export { AdsFiller };
